export const engagementAppGroupIdCanvasWorkflowIdVersionsVersionId =
  "/engagement/:app_group_id/canvas/:workflow_id/versions/:version_id";
